import { useQuery } from "@tanstack/react-query";
import apiV2 from "api-v2";
import type { DisclaimerModalData } from "../types/panel.type";

export const useDisclaimerModalData = (
	rfxId: number,
	evalId: number,
	memberId: number,
	enabled: boolean
) => {
	return useQuery<DisclaimerModalData>({
		queryKey: ["disclaimer-modal", rfxId, evalId, memberId],
		queryFn: () =>
			apiV2
				.get(
					`/rfx/${rfxId}/evaluation/${evalId}/panel-members/${memberId}/disclaimer`
				)
				.then((r) => r.data?.data ?? r.data),
		enabled,
	});
};
